import fetchJSON from '@api/api_helper';

const get = (params, options = {}) => {
  const {
    activeSection,
    isCollection,
    resourceKey,
    resourceType,
    sectionKey,
    showSections,
  } = options;

  const {
    identity_ids,
    labelKeys,
    onlyKeys,
    search,
  } = params;

  let url = '/api/v4';

  // if sectionless, use resource/:resource_key/assets endpoint
  // UNLESS.. sectionless AND user selects a section pill, need to use sections/:section_key... endpoint
  const performSectionlessFetch = !showSections && activeSection === 'all';

  // Determine if we need POST (for search, labelKeys, or identity_ids arrays)
  const needsPostRequest = !!search || labelKeys || (identity_ids && identity_ids.length > 0);

  if (performSectionlessFetch || isCollection) {
    url += `/${resourceType}s/${resourceKey}`;
  }

  if (performSectionlessFetch) {
    // label keys need to be included in the body of a POST to avoid overly long
    // GET urls, since the POST at '.../assets' is a #create action, we use '.../assets/search'
    // here so that the POST hits the #index action of '.../assets'
    url += needsPostRequest ? '/assets/search' : '/assets';
  } else {
    url += `/sections/${sectionKey}/asset${onlyKeys ? '_keys' : 's'}`;

    if (needsPostRequest && !onlyKeys) {
      url += '/search';
    }
  }

  // Arrays (label keys, identity_ids) must be included in the body of a POST to avoid
  // making the GET url too long or improperly serialized
  const method = needsPostRequest ? 'POST' : 'GET';

  const fetchController = options.fetchController || (() => {});

  let body = {};
  if (method === 'POST') {
    body = { ...params };

    if (labelKeys) {
      body.label_keys = labelKeys; // camel to snake case
      delete body.labelKeys; // eslint-disable-line no-param-reassign
    }
  }

  return fetchJSON(url, {
    method,
    ...Object.keys(body).length ? { body } : { params },
  }, fetchController).then((response) => {
    if (!response.meta) {
      return {
        assets: response.data,
        included: response.included
      };
    }

    return {
      assets: response.data,
      included: response.included,
      total: response.meta.total_count,
      totalPages: response.meta.total_pages,
      currentPage: response.meta.current_page,
      resultConsistency: response.meta.result_consistency,
      resultHash: response.meta.result_hash,
      vsAttachmentIds: response.meta.vs_attachment_ids || [],
      nlsScores: response.meta.nls_scores || {},
      nlsEsQuery: response.meta.nls_es_query || null,
    };
  });
};

export const getSectionAssetCounts = (params, options = {}) => {
  const { resourceKey } = options;
  const { labelKeys } = params;

  const needsPost = !!labelKeys;
  const url = `/api/v4/brandfolders/${resourceKey}/section_asset_counts`;

  let body = {};
  if (needsPost) {
    body = { ...params };
    body.label_keys = labelKeys;
    delete body.labelKeys;
  }

  return fetchJSON(url, {
    method: needsPost ? 'POST' : 'GET',
    ...Object.keys(body).length ? { body } : { params },
  }).then((response) => response.data);
};

export default get;
